<template>
  <RCard class="subscriptions">
    <div class="text-subtitle-1 text-secondary-2">Subscriptions</div>

    <GridTable :columns="tableColumns" :rows="data">
      <template #row="{row}">
        <GridTableCell no-tooltip>
          <router-link :to="`/subscriptions/${row.id}`" class="link text-body-1 text-link-blue">
            {{ row.name }}
          </router-link>
        </GridTableCell>
      </template>
    </GridTable>
  </RCard>
</template>

<script>
// Components
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  name: 'TabSubscriptions',

  components: {
    GridTable,
    GridTableCell
  },

  props: {
    data: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    tableColumns() {
      return [{ label: 'Subscription', width: '1fr' }]
    }
  }
}
</script>

<style lang="scss" scoped>
.subscriptions {
  .link {
    text-decoration: none;
  }
}
</style>
